module.exports = __webpack_public_path__ + "img/zhyldyz-academy.c178f1ff.jpeg";